import React, { ChangeEvent, FormEvent, useState } from "react";
import { Col, Form, FormGroup, Input, Label, Button, Card } from "reactstrap";
import axios, { AxiosError } from "axios";
import { LoginFormProp } from "../../../../../Types/Others.type";
import { useNavigate } from "react-router-dom";

import { baseUrl } from "../../../../../Utils/Baseurl/Baseurl";
import "./Registration.css";

import { toast } from "react-toastify";

export default function RegisterTeam({ logoClass }: LoginFormProp) {
  const navigate = useNavigate();

  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const togglePassword = () => setPasswordVisible(!isPasswordVisible);
  const [passwordError, setPasswordError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactdetails: "",
    password: "",
    employeeId: "",
    designation: "",
    checkbox1: false,
  });
  const validatePassword = (password: string) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
    return passwordRegex.test(password);
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    if (id === "password") {
      if (!validatePassword(value)) {
        setPasswordError(
          "Password must have at least 6 characters, one uppercase letter,one lowercase letter, one number, and one special character."
        );
      } else {
        setPasswordError("");
      }
    }

    // Ensure only numbers are accepted for contactdetails
    if (id === "contactdetails") {
      if (!/^\d*$/.test(value)) return; // Prevent non-numeric input
    }

    setFormData({ ...formData, [id]: value });
  };
// const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     if (!validatePassword(formData.password)) {
//       toast.error(
//         "Password must have at least 6 characters, one uppercase letter, one lowercase letter,one number, and one special character."
//       );
//       return;
//     }

//     try {
//       const payload = {
//         name: formData.name,
//         contactdetails: formData.contactdetails,
//         employeeId: formData.employeeId,
//         designation: formData.designation,
//         email: formData.email,
//         password: formData.password,
//         usertype: 2, // Assuming purchase team user type is 2
//       };

//       const response = await axios.post(
//         baseUrl + "purchaseteam/createPurchase",
//         payload
//       );
//       console.log(response.data, "response");
//       if (response.status === 201) {
//         toast.success("Registration Success!");

//         // Reset form fields
//         setFormData({
//           name: "",
//           email: "",
//           contactdetails: "",
//           password: "",
//           designation: "",
//           employeeId: "",
//           checkbox1: false,
//         });

//         setTimeout(() => {
//           navigate("/admiro/purchaseteam"); // Redirect to login
//         }, 3000); // Optional delay to give toast message time to show
//       } else {
//         toast.error("Error registering medical representative!");
//       }
//     } catch (error) {
//       if (axios.isAxiosError(error)) {
//         console.error("Registration Error:", error);
//         toast.error(
//           error.response?.data?.message ||
//             "An error occurred during registration."
//         );
//       } else {
//         console.error("Unexpected Error:", error);
//         toast.error("An unknown error occurred!");
//       }
//     }
//   };
const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  if (!validatePassword(formData.password)) {
    toast.error(
      "Password must have at least 6 characters, one uppercase letter, one lowercase letter, one number, and one special character."
    );
    return;
  }

  try {
    const payload = {
      name: formData.name,
      contactdetails: formData.contactdetails,
      employeeId: formData.employeeId,
      designation: formData.designation,
      email: formData.email,
      password: formData.password,
      usertype: 2,
    };

    const response = await axios.post(baseUrl + "purchaseteam/createPurchase", payload);

    if (response.status === 201) {
      toast.success("Registration Success!");

      // Reset form fields
      setFormData({
        name: "",
        email: "",
        contactdetails: "",
        password: "",
        designation: "",
        employeeId: "",
        checkbox1: false,
      });

      setTimeout(() => {
        navigate("/admiro/purchaseteam");
      }, 3000);
    } else {
      toast.error("Error registering purchase team!");
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Registration Error:", error);
      
      if (error.response?.status === 409) {
        // Handle duplicate errors
        toast.error(error.response.data.message || "Duplicate entry detected!");
      } else {
        toast.error(error.response?.data?.message || "An error occurred during registration.");
      }
    } else {
      console.error("Unexpected Error:", error);
      toast.error("An unknown error occurred!");
    }
  }
};


  return (
    <>
      <Col sm={12}>
        <Card>
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "75%",
            }}
          >
            <div className=" m-5">
              <Form className="theme-form" onSubmit={handleSubmit}>
                <h2 className="text-center">Add Employee</h2>
                <p className="text-center">
                  {"Enter details to create an account"}
                </p>

                {/* Name of Purchase Team */}
                <FormGroup style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "30%" }}>
                    Full Name<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    id="name"
                    required
                    placeholder="Full name"
                    value={formData.name}
                    onChange={handleInputChange}
                    style={{ flex: 1 }}
                  />
                </FormGroup>

                {/* Employee ID */}
                <FormGroup style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "30%" }}>
                    Employee ID<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="number"
                    id="employeeId"
                    required
                    placeholder="Enter Employee ID"
                    value={formData.employeeId}
                    onChange={handleInputChange}
                    style={{ flex: 1 }}
                  />
                </FormGroup>

                {/* Designation */}
                <FormGroup style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "30%" }}>
                    Designation<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    id="designation"
                    required
                    placeholder="Enter Your Designation"
                    value={formData.designation}
                    onChange={handleInputChange}
                    style={{ flex: 1 }}
                  />
                </FormGroup>

                {/* Contact */}
                <FormGroup style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "30%" }}>
                    Contact<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="tel"
                    id="contactdetails"
                    required
                    placeholder="1234567890"
                    value={formData.contactdetails}
                    onChange={handleInputChange}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    style={{ flex: 1 }}
                  />
                </FormGroup>

                {/* Email */}
                <FormGroup style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "30%" }}>
                    Email<span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="email"
                    id="email"
                    required
                    placeholder="Test@gmail.com"
                    value={formData.email}
                    onChange={handleInputChange}
                    style={{ flex: 1 }}
                  />
                </FormGroup>
                {/* Password */}
                <FormGroup style={{ display: "flex", alignItems: "center" }}>
                  <Label style={{ width: "30%" }}>
                    Password<span style={{ color: "red" }}>*</span>
                  </Label>
                  <div style={{ flex: 1, position: "relative" }}>
                    <Input
                      type={isPasswordVisible ? "text" : "password"}
                      id="password"
                      required
                      placeholder="*********"
                      value={formData.password}
                      onChange={handleInputChange}
                      style={{ paddingRight: "40px" }} // Make space for the show button
                    />
                    <div
                      className="show-hide"
                      onClick={togglePassword}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {isPasswordVisible ? "👁️" : "👁️‍🗨️"}{" "}
                      {/* Eye Icon for Show/Hide */}
                    </div>
                  </div>
                </FormGroup>

                {/* Submit Button */}
                <FormGroup className="text-center mt-3">
                  <Button color="primary" size="md" style={{ width: "50%" }}>
                    Create
                  </Button>
                </FormGroup>
              </Form>
            </div>
          </div>
        </Card>
      </Col>
    </>
  );
}
